import { Drawer } from "@mui/material";
import "./CartPopUpComponent.scss";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import ProductCardComponent from "../../ProductCard/ProductCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, addToCartClear, product } from "../../../../redux/product/actions";
import { useEffect, useRef, useState } from "react";
import { SessionKeys } from "../../../../utils/AppUtils";
import _ from "lodash";
import { CheckoutLockIcon, ShoppingCartIcon } from "../../../../utils/SvgComps";
import { cartPageDataResponse, providerSubscriptionCheckoutPage, subscriptionCheckoutPage } from "../../../../redux/checkout/actions";
import { useNavigate } from "react-router-dom";
import { routeList } from "../../../../utils/routeList";
import ConfirmModal from "../../../modal/ConfirmModal";
import useLogin from "../../../../custom-hooks/useLogin";
import { myCart } from "../../../../redux/Cart/actions";
import { useTranslation } from "react-i18next";
const CartPopUpComponent = (props) => {
  const {
    productData,
    isOpen,
    closeAction,
    isSubscription,
    setMainPageLoading,
    isMobile,
    entityType,
  } = props;

  const ref = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoggedIn } = useLogin();
  const {t} = useTranslation();
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const addToCartRes = useSelector((state) => state.product.addToCart);

  const [userDetails, setUserDetails] = useState("");
  const [totalPrice, setTotalPrice] = useState(productData.price);
  const [ticked, setTicked] = useState("annually");
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState("");
  const [disabledAddToCart, setDisabledAddToCart] = useState(false)
  const [cartLoader, setCartLoader] = useState(false)
  const [checkoutLoader, setCheckoutLoader] = useState(false)
  const [productType, setProductType] = useState('')

  useEffect(() => {
    return () => setDisabledAddToCart(false)
  }, [dispatch])

  useEffect(() => {
    setUserDetails(userDetailRes?.payload?.payload);
  }, [userDetailRes]);

  useEffect(() => {
    console.log('ADD TO CART1', addToCartRes,isMobile)
    if (!_.isEmpty(addToCartRes)) {
      if (addToCartRes.status === 'success') {
        console.log('ADD TO CART1 success', addToCartRes,isMobile)
          if (!isLoggedIn) {
          console.log('ADD TO CART', addToCartRes)
          const payload = addToCartRes.payload?.payload
          if (!_.isEmpty(payload) && payload.user_id) {
            localStorage.setItem(SessionKeys.SESSION_ID, payload.user_id)
          }
        }
        if(isMobile) {
          // let obj =  {type: entityType ,user_id: addToCartRes.payload?.payload?.user_id, method:"click-on-add-to-cart" };
          let obj= {
            type: entityType,
            method:"click-on-add-to-cart",
            user_id: addToCartRes.payload?.payload?.user_id,
        }
          if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(JSON.stringify(obj));
        }
        if (window.webkit != undefined) {
            if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                   JSON.stringify(obj)
                );
            }
        }
        }
        setDisabledAddToCart(true)
        dispatch(myCart({module: "myCart"}))
      }
      setCartLoader(false)
      setMainPageLoading(false)
      dispatch(addToCartClear());
      
    }
  }, [addToCartRes]);

  useEffect(() => {
    console.log(productData);
    if (!_.isEmpty(productData)) {
      setTotalPrice(productData?.price)
      setProductType(productData?.productType ? productData.productType : "");
      if (isSubscription && !_.isEmpty(productData)) {
        if (
          productData.priceInfo.monthly > 0 &&
          productData.priceInfo.yearly > 0
        ) {
          setTotalPrice(productData.priceInfo.yearly * 12);
          setTicked("annually");
        } else if (productData.priceInfo.monthly > 0) {
          setTotalPrice(productData.priceInfo.monthly);
          setTicked("monthly");
        } else if (productData.priceInfo.yearly > 0) {
          setTotalPrice(productData.priceInfo.yearly * 12);
          setTicked("annually");
        }
      }
    }
  }, [productData]);

  useEffect(() => {
    if (isSubscription && !_.isEmpty(productData)) {
      if (ticked === "annually") {
        setTotalPrice(productData.priceInfo.yearly * 12);
      } else if (ticked === "monthly") {
        setTotalPrice(productData.priceInfo.monthly);
      }
    }
  }, [ticked]);

  const addToCartAction = () => {
    setMainPageLoading(true)
    let postData = {
      pid: productData.id,
      email: userDetails?.email
        ? userDetails?.email
        : localStorage.getItem(SessionKeys.EMAIL_ID),
      first_name: userDetails?.firstname,
      last_name: userDetails?.lastname,
      username: userDetails?.username,
      company: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      postcode: "",
      country: "",
      phone: "",
      isPremium: isPremiumUser,
      broker_id: userDetails?.broker_id,
      company_id: userDetails?.company_id,
    }
    if (!isLoggedIn) postData.session_id = localStorage.getItem(SessionKeys.SESSION_ID)
    dispatch(
      addToCart({
        module: "addToCart",
        postData
      })
    );
  };

  const renderSubscriptionCheckbox = () => {
    return (
      <div className="row d-flex justify-content-between align-items-center subscription-price">
        {productData.priceInfo.monthly > 0 && (
          <div className="col-6 d-flex align-items-center">
            <input
              type="checkbox"
              className="cursor-pointer"
              id="b-monthly"
              checked={ticked === "monthly"}
              onChange={(e) => {
                if (e.target.checked) {
                  setTicked("monthly");
                } else {
                  productData.priceInfo.yearly > 0
                    ? setTicked("annually")
                    : setTicked("");
                }
              }}
              disabled={productData.priceInfo.yearly <= 0}
            />
            <label htmlFor="b-monthly" className="checkbox-label">
              ${productData.priceInfo.monthly}, billed monthly
            </label>
          </div>
        )}
        {productData.priceInfo.yearly > 0 && (
          <div className="col-6 d-flex align-items-center">
            <input
              type="checkbox"
              className="cursor-pointer"
              id="b-annually"
              checked={ticked === "annually"}
              onChange={(e) => {
                if (e.target.checked) {
                  setTicked("annually");
                } else {
                  productData.priceInfo.monthly > 0
                    ? setTicked("monthly")
                    : setTicked("");
                }
              }}
              disabled={productData.priceInfo.monthly <= 0}
            />
            <label htmlFor="b-annually" className="checkbox-label">
              ${productData.priceInfo.yearly}/month, billed annually
            </label>
          </div>
        )}
      </div>
    );
  };

  const redirectTo = () => {
    console.log("PRODUCT DATA", productData);
    if (isSubscription) {
      if (productType === 'subscription-product') {
        redirectToProviderCheckoutPage()
      } else {
        if (productData.isUpgradePlan) {
          console.log("Currently plan is active");
          setConfirmMsg(`You are already subscribed to Halifax ${productData.subscribedPlanName}. 
                  Are you sure, you want to switch to Halifax ${productData.cardTitle}?`);
          setConfirmModal(true);
        } else if (productData.isDowngradePlan) {
          setConfirmMsg(`You are already subscribed to higher plan (Halifax ${productData.subscribedPlanName}). 
                  Switching to lower plan, will reduced the benefits. Are you sure, you want to switch to Halifax ${productData.cardTitle}?`);
          setConfirmModal(true);
        } else {
          setCheckoutLoader(true)
          redirectToSubPaymentPage();
        }
      }
    } else {
      setCheckoutLoader(true)
      dispatch(cartPageDataResponse({load: true, productId: productData.id}));
      setMainPageLoading(true)
      setTimeout(() => {
        navigate(routeList.PAYMENT_PAGE_PRODUCT, {state:{isMobile : isMobile}})
      }, 2000)
    }
  };

  const redirectToProviderCheckoutPage = () => {
    setMainPageLoading(true)
    setTimeout(() => {
      closeAction();
      dispatch(
        providerSubscriptionCheckoutPage({
          productId: productData.id,
          priceType: productData.priceType,
          productType: productData.productType
        })
      )
      navigate(routeList.COACHING_CHECKOUT_PAGE,{state:{isMobile : isMobile}})
    }, 500)
  }

  const redirectToSubPaymentPage = () => {
    setMainPageLoading(true);
    setTimeout(() => {
      closeAction();
      dispatch(
        subscriptionCheckoutPage({
          subscriptionId: productData.id,
          billingType: ticked,
        })
      );
      navigate(routeList.PAYMENT_PAGE_SUBSCRIPTION, {state:{isMobile : isMobile}});
    }, 500);
  };

  return (
    <>
      <Drawer anchor="right" className="cart-drawer" open={isOpen} onClose={closeAction}>
        {!_.isEmpty(productData) ? (
          <div className="cart-popup-wrapper">
            <div className="car-checout-inner">
              <div className="cart-title-section">
                <div className="d-flex justify-content-between align-items-center cart-head">
                  <span className="cart-title">{t("Quick checkout")}</span>

                  <svg
                    className="close-btn-popup cursor-pointer"
                    ref={ref}
                    onClick={closeAction}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="cart-desc">
                  {t("Go directly to billing and payment.")}
                </div>
              </div>
              <div className="product-cart-inner">
                <ProductCardComponent
                  title={productData.title}
                  logoAltText={productData.logoAltText}
                  logoURL={productData.logoURL}
                  bannerURL={productData.bannerURL}
                  description={productData.description}
                  tagsArray={productData.tagsArray}
                  bannerAction={() => {}}
                  footerLineComp={() => {}}
                  showHeader={true}
                  showBody={false}
                  showFooter={false}
                  showProviderIcon={true}
                  lastKey={false}
                  showPlayButton={false}
                  showProgress={false}
                  cardClassName="product-card-cart"
                  leftBtnIcon="/images/arrow-right.svg"
                  rightBtnIcon=""
                  priceInfo={productData?.priceInfo}
                  isBundle={productData?.isBundle ? productData?.isBundle : false}
                  bundles={!_.isEmpty(productData?.bundleList) ? productData.bundleList : []}
                />

                {isSubscription ? (
                  renderSubscriptionCheckbox()
                ) : (
                  <div className="product-price">
                    {/* {
                      !_.isEmpty(productData.priceInfo) ?
                        <div dangerouslySetInnerHTML={{
                          __html: productData.priceInfo.showText}}></div>
                      :
                      <div>Price: ${productData.price}</div>
                    } */}
                    {/* <div>Price: ${productData.price}</div> */}
                  </div>
                )}
              </div>
            </div>
            <div className="cart-popup-footer">
              <div className="cart-price-total">
                <hr />
                <div className="cart-total-section d-flex align-items-start justify-content-between">
                  <div>
                    {t("Total")}
                    <span>{t("Excl. of taxes")}</span>
                  </div>
                  <div>
                    {/* ${totalPrice ? totalPrice.toFixed(2) : ""} */}
                    {productData?.priceText ? productData?.priceText : totalPrice ? `$ ${totalPrice.toFixed(2)}` : ""}
                    {
                      isSubscription && productType == 'subscription-product'
                      ?
                      _.toLower(productData?.priceType) == 'monthly'
                      ? '/ month' : ""
                      : ""
                    }
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="d-flex justify-item-start btn-cart-row justify-content-end">
                  <div className="cart-btn-popup">
                    {!isSubscription &&
                    <><FormButtonComponent
                      isPrimary={false}
                      leftIcon={<ShoppingCartIcon />}
                      btnName={t("Add to cart")}
                      btnAction={() => {
                        setCartLoader(true)
                        addToCartAction()
                      }}
                      showLoader={cartLoader}
                      isDisabled={productData.priceInfo?.isAddToCart || disabledAddToCart}
                    />
                    {productData.priceInfo?.isAddToCart ?
                    <div className="w-100 text-center added-cart-text">{t("In Cart")}</div> :
                    disabledAddToCart ? <div className="w-100 text-center added-cart-text">{t("Added In Cart")}</div> : ""}</>}
                  </div>
                  <div className="ddfbtn">
                    <FormButtonComponent
                      isPrimary={true}
                      leftIcon={<CheckoutLockIcon />}
                      btnName={t("Checkout")}
                      btnAction={() => {
                        redirectTo()
                      }}
                      showLoader={checkoutLoader}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </Drawer>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={confirmMsg}
        isConfirm={true}
        confirmId=""
        confirmAction={() => redirectToSubPaymentPage()}
        isRightIcon=""
      />
    </>
  );
};

export default CartPopUpComponent;
